<template>
  <div>
    <myHeader class="my-header"></myHeader>

    <div class="demo-collapse mobile">
      <div class="banner">
        <img class="banner-img" src="../assets/banner4.jpg" alt="" />
        <div class="page-title">
          <div>加入我们</div>
          <div>JOIN US</div>
        </div>
      </div>

      <div class="join-content">
        <strong>才者，德之资也；德者，才之帅也。</strong>
        <br />
        在我们这个充满活力的组织中，我们凭借敏锐的洞察力，细致入微地探寻每一位员工的独特个性与潜力。我们深知，每个人都是独一无二的，拥有各自擅长的领域和独特的才华。因此，我们致力于做到量才而用，将人才放在最能够发挥其价值的岗位上。<br />
        在生产部门，我们期待那些有着丰富生产经验，助力我们不断优化生产流程，提升产品质量。<br />
        在销售部门，我们寻求可以完成产品的市场开拓与渠道建设，完成公司下达的销售目标，帮助公司的销售业绩更上一层楼。<br />
        在运营部门，我们渴望拥有卓越市场洞察力、营销策略制定和执行能力的精英。你们的智慧和创意，将帮助我们更好地把握市场动态，推动销售业绩的稳步增长。<br />
        如果您是以上领域的佼佼者，或是对我们的工作充满热忱，请将您的简历及相关学历、职业证书发送至邮箱：<span
          class="join-email"
          >609490374@qq.com</span
        >
        我们期待着您的加入，共同书写属于我们的辉煌篇章！
      </div>
    </div>

    <myFooter class="footer"></myFooter>
  </div>
</template>

<script>
import myFooter from "../components/myFooter.vue";
import myHeader from "../components/myHeader.vue";

export default {
  data() {
    return {
      activeNames: "",
    };
  },
  components: {
    myFooter,
    myHeader,
  },

  methods: {
    handleChange: (val) => {
      console.log(val);
    },
  },
};
</script>

<style lang="less" scoped>
.demo-collapse {
  margin: 90px 0 0px 0;
  .banner {
    width: 100%;

    .banner-img {
      width: 100%;
    }
  }
  position: relative;
  z-index: -1;
  .page-title {
    font-size: 40px;
    font-weight: 700;
    line-height: 80px;
    height: 80px;
    position: absolute;
    width: 100%;
    text-align: center;
    top: 100px;
    color: white;
    letter-spacing: 20px;
  }
  .join-content {
    padding: 0 10%;
    margin-top: 50px;
    line-height: 40px;
    .join-email {
      color: rgb(255, 0, 0);
      text-decoration: underline;
    }
  }
}

.footer {
  // position: absolute;
  bottom: 0;
  width: 100%;
  margin-top: 50px;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 18px;
  }


  .footer {
    position: relative;
    bottom: 0;
    width: 100%;
  }

  .mobile {
    .page-title{
      font-size: 20px;
      top: 10px;
      line-height: 40px;
    }
  }
}
</style>
